module.exports = __webpack_public_path__ + "img/main-hero-3.bea6341d.jpeg";